// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","461":"b637e9a5","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"04a3b2141cc63b15f59d","293":"81848df50a81337233b3","461":"23b312cad135d434e0a4","518":"88131538b3aa5246046a","779":"13aec759083d0b2ac2a3"}[chunkId] + ".js";
};